import { ReactElement, ReactNode } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import pendingRequestsStyle from '../../Styles/ComponentStyles/PendingRequests/PendingRequests.module.scss';

interface PendingRequestsTableTooltipProps {
    title: ReactNode;
    subtitle?: string;
    children: ReactElement;
    disable?: boolean;
}

export function PendingRequestsTableTooltip({
    title,
    subtitle,
    children,
    disable = false,
}: PendingRequestsTableTooltipProps) {
    if (disable || title === '' || title === '—') {
        return children;
    }

    const tooltipTitle = subtitle ? (
        <Box className={pendingRequestsStyle.dataGridTooltipInner}>
            <Typography component="span" className={pendingRequestsStyle.dataGridTooltipLabel}>
                {subtitle}
            </Typography>
            <Typography component="span" className={pendingRequestsStyle.dataGridTooltipBody}>
                {title}
            </Typography>
        </Box>
    ) : (
        <Typography component="span" className={pendingRequestsStyle.dataGridTooltipBody}>
            {title}
        </Typography>
    );

    return (
        <Tooltip
            title={tooltipTitle}
            arrow
            placement="top"
            enterDelay={400}
            enterNextDelay={200}
            componentsProps={{
                tooltip: { className: pendingRequestsStyle.dataGridTooltip },
                arrow: { className: pendingRequestsStyle.dataGridTooltipArrow },
            }}
        >
            <Box component="span" className={pendingRequestsStyle.overflowTooltipTrigger}>
                {children}
            </Box>
        </Tooltip>
    );
}
